export const scribeEnterSearchMode = () => ({
    type: 'SCRIBE_ENTER_SEARCH_MODE',
});
export const scribeExitSearchMode = () => ({
    type: 'SCRIBE_EXIT_SEARCH_MODE',
});
export const scribeUpdateSearchQuery = (query) => ({
    type: 'SCRIBE_UPDATE_SEARCH_QUERY',
    query,
    selectedSearchMatchIndex: 0,
});
export const scribeNextSearchMatch = () => ({
    type: 'SCRIBE_NEXT_SEARCH_MATCH',
});
export const scribePreviousSearchMatch = () => ({
    type: 'SCRIBE_PREVIOUS_SEARCH_MATCH',
});
